import { render, staticRenderFns } from "./consumeProp.vue?vue&type=template&id=5ec6ac88&scoped=true&"
import script from "./consumeProp.vue?vue&type=script&lang=js&"
export * from "./consumeProp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec6ac88",
  null
  
)

export default component.exports